import { Spin, Modal } from 'antd';
import React, { useState } from 'react';
import SubunitAssetForm from './SubunitAssetForm';
import { updateAsset } from '../../services/subunitService';

const subunitTypeToAssetMap = {
  Video: 'video',
  Exercise: 'exercise',
  Certificate: 'certificate'
};

function SubunitAssetEdit(props) {
  const { subunitType, subunitAsset } = props;
  let asset = subunitAsset[subunitTypeToAssetMap[subunitType]];

  const initialValues = {
    //video properties
    subtitles: asset?.subtitles,
    duration: asset?.duration,
    link: asset?.link,
    hlsLink: asset?.hlsLink,
    thumbnailLink: asset?.thumbnailLink,

    //exercise-resource properties
    fileName: asset?.file?.name,
    fileLink: asset?.file?.link,
    'resource-exerciseTitle': asset?.title,
    'resource-exerciseDescription': asset?.description,
    'resource-exerciseLongDescription': asset?.longDescription,
    deadlineText: asset?.deadlineText,
    ctaBtnText: asset?.ctaBtnText,
    ctaBtnIcon: asset?.ctaBtnIcon,
    category: asset?.category,

    //certificate properties
    imgData: asset?.imgData
  };

  const [status, setStatus] = useState({
    type: 'IDLE',
    message: 'In idle mode'
  });

  const onSubmit = async (values) => {
    const identifier =
      subunitAsset[subunitTypeToAssetMap[subunitType]]._id;

    if (subunitType.toLowerCase() === 'exercise') {
      values = {
        ...values,
        title: values['resource-exerciseTitle'],
        description: values['resource-exerciseDescription'],
        longDescription: values['resource-exerciseLongDescription'],
        file: {
          name: values.fileName,
          link: values.fileLink
        }
      };
    }
    let payload = {
      _id: identifier, //asset Id is either the exerciseId or videoId
      ...values
    };

    await updateAsset(payload, subunitType)
      .then((response) => {
        console.log('Successfully Updated! ', response);
        setStatus({
          type: 'SUCCESS',
          message: 'Data updated successfully!'
        });
      })
      .catch((error) => {
        alert('Posting data from the backend failed!');
        if (error?.response?.data?.message)
          setStatus({
            type: 'ERROR',
            message: error.response.data.message
          });
        else
          setStatus({ type: 'ERROR', message: 'Something went wrong!' });
      });
  };

  return (
    <Modal
      title={`Edit asset ${asset?.title}`}
      visible={props.isOpen}
      onCancel={() => props.toggle()}
      footer={null}>
      {status.type === 'LOADING' ? (
        <Spin size="large" />
      ) : (
        <SubunitAssetForm
          type="Update"
          initialValues={initialValues}
          onSubmit={onSubmit}
          subunitType={subunitType}
          status={status}
          visible={true}
        />
      )}
    </Modal>
  );
}

export default SubunitAssetEdit;
